export function touchScroll() {
    const container = document.querySelector('.p-top-table__scroll-container');
    if (!container) return;

    let startX, startY;
    let startScrollLeft, startScrollTop;

    container.addEventListener('touchstart', (e) => {
        startX = e.touches[0].pageX;
        startY = e.touches[0].pageY;
        startScrollLeft = container.scrollLeft;
        startScrollTop = container.scrollTop;
    });

    container.addEventListener('touchmove', (e) => {
        const x = e.touches[0].pageX;
        const y = e.touches[0].pageY;
        const dx = startX - x;
        const dy = startY - y;
        container.scrollLeft = startScrollLeft + dx;
        container.scrollTop = startScrollTop + dy;
        // Remove e.preventDefault() to allow native scrolling
    });
}
